import React from 'react'
import TeacherUpdateProfile from '../../Components/TeacherComponents/TeacherUpdateProfile/TeacherUpdateProfile'

function UpdateTeacherProfile() {
  return (
    <div>
        <TeacherUpdateProfile/>
    </div>
  )
}

export default UpdateTeacherProfile